import { createReducer } from '@reduxjs/toolkit';
import { initialState } from '../default';

import { getTherapeuticList } from './actions';
import { TherapeuticState } from './types';

export default createReducer(initialState as TherapeuticState, builder => {
  builder
    .addCase(getTherapeuticList.pending, state => {
      state.pending = true;
    })
    .addCase(getTherapeuticList.fulfilled, (state, { payload }) => {
      state.pending = false;
      state.fullfilled = true;
      state.data = payload;
    })
    .addCase(getTherapeuticList.rejected, state => {
      state.pending = false;
      state.error = true;
    });
});
